/** @jsxRuntime classic */
/** @jsx jsx */
/** @jsxFrag React.Fragment */
// @ts-check
import {
  Box,
  Button,
  ChevronRightIcon,
  Flex,
  StarIcon,
} from '@bottlebooks/gatsby-theme-base';
import { ListRowBody } from '@bottlebooks/gatsby-theme-event/src/components/List';
import ProductHeader from '@bottlebooks/gatsby-theme-event/src/components/Product/ProductHeader';
import ProductImage from '@bottlebooks/gatsby-theme-event/src/components/Product/ProductImage';
import ProductListRowSmall from '@bottlebooks/gatsby-theme-event/src/components/SiteSearch/ProductListRowSmall';
import { useProduct } from '@bottlebooks/gatsby-theme-event/src/components/SiteSearch/useEventData';
import useLink from '@bottlebooks/gatsby-theme-event/src/useLink';
import React from 'react';
import { jsx } from 'theme-ui';
import {
  TastingNoteButton,
  useTastingNote,
} from '../../../gatsby-plugin-tastingnotes/src';
import { useFavorite } from '../useFavorite';

/**
 * @param {object} props
 * @param {string} props.productId
 * @param {import('react').MouseEventHandler} [props.onClick]
 * @param {string} [props.to]
 * @param {string} [props.listId]
 */
export default function FavoriteProduct({
  productId,
  onClick,
  to,
  listId,
  ...rest
}) {
  const link = useLink();
  const product = useProduct(productId);
  const favorite = useFavorite({ type: 'product', id: productId });

  const { tastingNote } = useTastingNote({ productId });
  const hasTastingNote = Boolean(tastingNote);
  const { getIconProps } = TastingNoteButton.use({ product });
  if (!product) return null;
  return (
    <Flex
      align="center"
      sx={{ backgroundColor: favorite.isSet ? 'background' : 'light' }}
      {...rest}
    >
      <Flex
        as={to || onClick ? Button : undefined}
        // @ts-ignore
        onClick={onClick}
        to={to}
        align="center"
        sx={{ textAlign: 'left', padding: 0, paddingLeft: 2, flex: 1 }}
      >
        <ProductListRowSmall product={product} sx={{ paddingLeft: 0 }} />
      </Flex>
      {hasTastingNote && (
        <Box
          sx={{
            position: 'absolute',
            padding: '5px', // 40px to cover the small bottle image: 30px for smallMedium size + 2*5px for padding.
            marginLeft: 2,
            transition: 'opacity',
            opacity: 1,
            backgroundColor: favorite.isSet ? 'background' : 'light',
            '&&:hover': { opacity: 0 },
          }}
        >
          <TastingNoteButton.Icon {...getIconProps()} size="smallMedium" />
        </Box>
      )}
      <Button
        variant="text"
        onClick={() => {
          if (favorite.isSet) return favorite.unset();
          return favorite.set(listId ? { listId } : undefined);
        }}
      >
        <StarIcon
          variant={favorite.isSet ? 'filled' : 'hollow'}
          sx={{
            color: favorite.isSet ? 'primary' : 'lightestText',
            marginTop: 1,
          }}
        />
      </Button>
      <Button
        variant="text"
        to={link.product({ productId, exhibitorId: product.exhibitorId })}
      >
        <ChevronRightIcon />
      </Button>
    </Flex>
  );
}
